import React from 'react';
import { motion } from 'framer-motion';
export function EbookPreview() {
  return <section className="py-10 md:py-16 bg-white" data-id="element-80">
      <div className="max-w-3xl mx-auto px-4" data-id="element-81">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-82">
          <span className="text-copper font-bold tracking-[0.2em] text-sm uppercase" data-id="element-83">
            Mirá por dentro
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown mt-3 mb-3" data-id="element-84">
            Así verás el ebook{' '}
            <span className="text-terracotta italic" data-id="element-85">por dentro</span>
          </h2>
          <p className="text-gray-500 max-w-lg mx-auto text-sm" data-id="element-86">
            Patrones detallados, instrucciones claras y guías visuales paso a
            paso para cada raza.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="flex justify-center" data-id="element-87">
          {/* Mobile mockup frame */}
          <div className="relative mx-auto" style={{
          width: '280px'
        }} data-id="element-88">
            {/* Phone frame */}
            <div className="relative bg-gray-900 rounded-[2.5rem] p-3 shadow-2xl" data-id="element-89">
              {/* Notch */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-28 h-6 bg-gray-900 rounded-b-2xl z-10" data-id="element-90" />

              {/* Screen */}
              <div className="relative rounded-[2rem] overflow-hidden bg-black" data-id="element-91">
                <video src="https://cdn.shopify.com/videos/c/o/v/dc566009c6fb4b9096cf2c095d7ecad9.mp4" autoPlay loop muted playsInline className="w-full aspect-[9/16] object-cover" data-id="element-92" />
              </div>

              {/* Home indicator */}
              <div className="flex justify-center mt-2" data-id="element-93">
                <div className="w-24 h-1 bg-gray-600 rounded-full" data-id="element-94" />
              </div>
            </div>

            {/* Subtle reflection/glow */}
            <div className="absolute -inset-4 bg-copper/10 rounded-[3rem] blur-2xl -z-10" data-id="element-95" />
          </div>
        </motion.div>
      </div>
    </section>;
}